export interface ActivityStaffPanelAccess {
  active: boolean;
  commission: boolean;
  category: boolean;
  salesAgent: boolean;
  promo: boolean;
}

export function hasActivityStaffPanelContent(
  access: ActivityStaffPanelAccess,
): boolean {
  return (
    access.active ||
    access.commission ||
    access.category ||
    access.salesAgent ||
    access.promo
  );
}
